import { render, staticRenderFns } from "./RenderSVG.vue?vue&type=template&id=21d84d48&lang=pug&"
import script from "./RenderSVG.vue?vue&type=script&lang=ts&"
export * from "./RenderSVG.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports